import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import dash from "../../images/dash.webp"
import NGN from "../../images/NGN.png"
import {Link} from "react-router-dom"
import service1 from "../../images/service1.png"
import service2 from "../../images/service2.png"
import service3 from "../../images/service3.png"
import service4 from "../../images/service4.png"
import Collaborators from '../../components/shared/Collaborators';
import SolutionImage1 from "../../images/image1.png";
import SolutionImage2 from "../../images/image2.png";
import SolutionImage3 from "../../images/image3.png";
import SolutionImage4 from "../../images/image4.png";
import SolutionImage5 from "../../images/image5.png";
import compliance from "../../images/compliance.png";
import messionBg from "../../images/messionBg.png";
import Footer from '../../components/shared/Footer';
import solar1 from "../../images/spotlight.png";
import seed from "../../images/seed.png"
import wallet from "../../images/wallet.png"
import metaMake from "../../images/MetaMask-icon.png"
import dollar from "../../images/dollar.png"
import search from "../../images/sreach.png"
import uniswap from "../../images/uniswap.png"
import Screenshot from "../../images/Screenshot.png"
import monitor from "../../images/monitor.png"
import iot from "../../images/iot.png"
import sus1 from "../../images/datawithSS.png"
import sus2 from "../../images/sus2.png"
import sus3 from "../../images/traffic.png"
import CloseCarbon_logo2 from "../../images/CloseCarbon_logo2.png"
import OurService from '../../components/NewLandingPage/OurService';
import StepByStepCornerImg from "../../images/step-by-step-corner.png";
import business_plus from "../../images/business_plus.png";
import Header from '../../components/shared/Header';
import ExploreLeading from '../../components/NewLandingPage/ExploreLeading';
import "../../styles/LandingPage.scss";

import { useNavigate } from 'react-router-dom';
import OurImpact from '../../components/NewLandingPage/OurImpact';
import { link } from 'fs';
import Section1 from '../../components/NewLandingPage/Section1';
import Overlaycard from '../../components/NewLandingPage/Overlaycard';
import Plans from '../../components/NewLandingPage/Plans';
import setUp from "../../images/setUp.png"

const HeroSection = () => {
  const heroRef = useRef(null);
  const marqueeRef = useRef(null);
  const [basicType, setBasicType] = useState(0);
  const [governanceType, setGovernanceType] = useState(4);
  const [verifierType, setVerifierType] = useState(13);
  const [businessType, setBusinessType] = useState(8);
  // Separate state for Business Plus (previously conflicted with businessType)
  const [businessPlusType, setBusinessPlusType] = useState(20);
const [activeSection, setActiveSection] = useState("subscription");

  const [howPlaying, setHowPlaying] = useState(false);

  const sectionRefs = {
    subscription: useRef(null),
    wallet: useRef(null),
    exchange: useRef(null),
    iot: useRef(null),
    getStarted: useRef(null),
  };

  // Reusable Counter Component

 


  // Plan data for the tabbed section (unchanged)
  const plans = [
    {
      name: 'Governance',
      price: '0',
      tag:"Free",
      title: 'CloseCarbon Governance',
      link:"/plans/governance",
      description: [
        'NDC Value (Nationally Determined Contributions)',
        'Government organization',
        'Private firms',
      ],
      features: [
        'Real-time tracking of NDC performance and sustainability targets ',
        'Independent validation of climate projects ',
        'Third-party verification of emissions data ',
        'Standard-aligned compliance framework ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) for verified reductions ',
        'Transparent oversight and reporting tools '
      ],
    },
    {
      name: 'Basic',
      price: '0',
      tag:"Free",

      title: 'CloseCarbon Basic',
      link:"/plans/basic",

      
      description: [
        'Renewable Energy Projects ',
        'Infrastructure Transition & Monitoring Projects',
      ],
      features: [
        'Project validation aligned with recognized standards ',
        'Verification of carbon reduction data ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Real-time carbon monitoring dashboard',
        'Structured emissions reporting',
        'Clear, traceable proof of emissions reduction '
      ],
    },
    {
      name: 'Business',
      price: '15,995',
      tag:"Monthly",
      title: 'CloseCarbon Business',
      link:"/plans/business",
      description: ['Gather Insights on Carbon emission data'],
      features: [
        'Real-time carbon emissions monitoring ',
        'Comprehensive carbon emissions reports',
        'Carbon Monitoring Certificate ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Optional review by Regional Oversight and Sub-CCVs (Non-Accredited Endorsing Bodies) for enhanced credibility ',
        'Verified documentation for sustainability reporting '
      ],
    },
    {
      name: 'Verifiers',
tag:"Free",
      price: '0',
      title: 'CloseCarbon Verifiers',
      link:"/plans/verifier",
      description: ['Whether you’re a beginner in your career or you’re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.',],
      features: [
        'Verification of project emissions and reductions ',
        'Structured data review tools ',
        'Compliance-based assessment framework ',
        'Standard-aligned verification workflow',
        'Reporting and approval documentation tools '
      ],
    },
    {
      name: 'Business Plus',
      link:"/plans/business-plus",
      price: '19,995',
      tag:"Monthly",
      title: 'CloseCarbon BusinessPlus',
      description: ['Decentralized Peer-to-Peer Energy Trading ', 'Blockchain-Based Smart Contracts', ],
      features: [
        'Real-time energy production and consumption tracking for decision-making ',
        'Secure marketplace for surplus renewable energy trading ',
        'Smart contract enabled transactions ',
        'Energy efficiency analytics and optimization tools ',
        'Carbon emissions reporting and certification ',
        'Issuance of CloseCarbon Reduction Tonnes (CCRTs) ',
        'Integrated monitoring of energy and carbon performance'


        , 
      ],
    },
  ];

  // const currentPlan = plans[activeTab];

  const cards = [
    {
      id: 1,
      image:setUp,
      title: "Set up your wallet for polygon",
      bullets: [
        "Configure polygon network",
        "Ensure you have MATIC",
        // third bullet hidden in this card, so we omit
      ],
      // imageLabel: "Screenshot 1",
      // optional: specify if title is single line? but we'll handle by content
    },
    {
      id: 2,
         image:uniswap,
      title: "Access the uniswap interface",

      bullets: [
        "Visit the uniswap website ",
        "Connect your wallet",
        "Switch to the polygon network", // third bullet visible
      ],
      imageLabel: "Group 1272628377",
    },
    {
      id: 3,
         image:Screenshot,
      title: "Prepare for swap and execute swap",
      bullets: [
        "Token approval",
        "Set up the trade",
      ],
      imageLabel: "Frame 1618873100",
    },
    {
      id: 4,
         image:monitor,
      title: "Monitor transaction",
      bullets: [
        "Check transaction on ploygon scan",
        "Confirm success",
      ],
      imageLabel: "Frame 1618873100",
      // Note: this card has title single line? but content same as card 3
      // The spec shows different width for bullets, but we'll ignore that
    },
  ];

   const leftPlans = [
    {

      title: "Basic Plan",
      link:"/plans/basic",
      description:
        "The basic plan is tailored for facilities looking to track their carbon emissions, emission reduction, and earn carbon incentives from the emission reduced.",
    },
       {
        link:"/plans/governance",
      title: "Governance Plan",
      description:
        "The governance plan is designed for governments and private organisations seeking to monitor activities aligned with Nationally Determined Contributions (NDCs) and generate value from verified emissions reduction.",
    },
    {
      title: "Verifier’s Plan",
      link:"/plans/verifier",
      description:
        "Whether you’re a beginner in your career or you’re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.",
    },
 
  ];

  const rightPlans = [
    {
      title: "Business Plan",
      link:"/plans/business",
      description:
        "The business plan is a paid plan designed for facilities looking to download their carbon emissions report and obtain a carbon monitoring certificate. It also includes energy efficiency insights to help facilities optimise energy use and reduce emissions. This plan is ideal for facilities assigned to a specific sub-CCV (verifier) for their facility.",
    },
    {
      title: "Business Plus Plan",
      link:"/plans/business-plus",
      description:
        "The business plus plan is a paid plan for facilities that offers powerful tools, for energy sharing and energy efficiency tracking, to help optimize consumption and trade surplus energy. It also include access to downloadable carbon report and official carbon monitoring certificate",
    },
  ];




  // Trigger fade animation when tab changes
  // useEffect(() => {
  //   setIsAnimating(true);
  //   const timer = setTimeout(() => setIsAnimating(false), 300);
  //   return () => clearTimeout(timer);
  // }, [activeTab]);

    const [email, setEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    // handle subscription logic
    console.log("Subscribed with email:", email);
    setEmail("");
  };
// faq data
 const [openIndex, setOpenIndex] = useState(0); // first item open by default

  const faqs = [
    {
      question: "Does CloseCarbon help reduce carbon footprint?",
      answer:
        "CloseCarbon enables you to monitor your carbon emissions in real-time, offering insights and tools for setting reduction goals.",
    },
    {
      question: "How does CloseCarbon ensure data accuracy?",
      answer:
        "CloseCarbon uses IoT sensors and blockchain verification to guarantee the integrity and accuracy of emissions data.",
    },
    {
      question: "Can I integrate CloseCarbon with my existing systems?",
      answer:
        "Yes, CloseCarbon provides APIs and supports integration with popular ERP and sustainability platforms.",
    },
    {
      question: "Is CloseCarbon compliant with international standards?",
      answer:
        "CloseCarbon aligns with ISO 14064, GHG Protocol, and supports various carbon credit standards like Verra and Gold Standard.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const navigate = useNavigate();

  const scrollToSection = (sectionKey) => {
    setActiveSection(sectionKey);
    const target = sectionRefs[sectionKey]?.current || document.getElementById(`step-by-step-${sectionKey}`);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const CheckIcon = () => (
    <div className="w-5 h-5 rounded-full bg-[#E7F6EC] flex items-center justify-center flex-shrink-0">
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4.5L4.5 8L11 1"
          stroke="#099137"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );

  const FeatureList = ({ items, textColor = "text-[#645D5D]" }) => (
    <div className="flex flex-col gap-6">
      {items.map((item, idx) => (
        <div key={idx} className="flex items-center gap-4">
          {/* <CheckIcon /> */}
          <svg width="14" height="14" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.09375 0.0898438C2.78006 0.0898438 0.09375 2.77616 0.09375 6.08984C0.09375 9.40372 2.78006 12.0898 6.09375 12.0898C9.40763 12.0898 12.0938 9.40372 12.0938 6.08984C12.0938 2.77616 9.40763 0.0898438 6.09375 0.0898438ZM6.09375 11.3517C3.19894 11.3517 0.84375 8.98466 0.84375 6.08982C0.84375 3.19501 3.19894 0.83982 6.09375 0.83982C8.98856 0.83982 11.3438 3.19502 11.3438 6.08982C11.3438 8.98462 8.98856 11.3517 6.09375 11.3517ZM8.48831 3.89441L4.96799 7.43684L3.38268 5.85153C3.23624 5.70509 2.99886 5.70509 2.85224 5.85153C2.7058 5.99797 2.7058 6.23534 2.85224 6.38178L4.7083 8.23803C4.85474 8.38428 5.09211 8.38428 5.23874 8.23803C5.25561 8.22116 5.27006 8.20277 5.28319 8.18366L9.01894 4.42483C9.16519 4.27839 9.16519 4.04102 9.01894 3.89441C8.87231 3.74797 8.63494 3.74797 8.48831 3.89441Z" fill="#099137" stroke="#099137" stroke-width="0.18"/>
</svg>

          <span className={`font-medium text-[18px] leading-[21px]  ${textColor}`}>
            {item}
          </span>
        </div>
      ))}
    </div>
  );

  const ServiceIcon = ({ icon: Icon, bgColor = "bg-[#E7F6EC]", iconColor = "text-[#0D924F]" }) => (
    <div className={`w-12 h-12 rounded-lg ${bgColor} flex items-center justify-center`}>
      <Icon className={`w-9 h-9 ${iconColor}`} />
    </div>
  );

  // ----- Service data (unchanged) -----

  useEffect(() => {
    // Simple entrance animation
    const ctx = gsap.context(() => {
      gsap.from(".hero-text", {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out"
      });

      gsap.from(".image", {
        x: 100,
        opacity: 0,
        duration: 0.2,
        delay: 1,
        stagger: 0.2,
        ease: "back.out(1.7)"
      });

      gsap.from(".hero-image-container", {
        x: 100,
        opacity: 0,
        duration: 1.2,
        delay: 0.2,
        ease: "in"
      });

      // Marquee infinite scroll setup (if needed via JS, but CSS is simpler for infinite loop)
    }, heroRef);

    return () => ctx.revert();
  }, []);

  const marqueeItems = [
    "Carbon Tracking", "Carbon Monitoring", "Carbon Offset Initiatives",
    "Sustainability", "Renewable Energy Solutions", "Educational Resources",
    // "Carbon Credits Program", "Environmental Impacts Reports",
    // "Government and Regulatory Guidance"
  ];

  // Duplicate list for seamless scrolling
  const seamlessMarquee = [...marqueeItems, ...marqueeItems, ...marqueeItems];

  // ----- Step-by-Step data for stack scroll effect -----
  const planSections = [
    {
      id:"/step-by-step-subscription",
      title: 'How to Register as a Basic Plan User',
      state: basicType,
      setState: setBasicType,
      image: SolutionImage1,
      steps: [
        { id: 0, title: 'Ensure the plan aligns with your facility needs', content: 'The basic plan is tailored for facilities looking to track their carbon emissions, reduce carbon emissions, and earn carbon incentives from the emission reduced.' },
        { id: 1, title: 'Choose plan, and fill the onboarding template form', content: 'Fill the form by providing your name, email, company name, industry, facility capacity (energy usage), facility category (green or non-green), and your wallet address.\n\nNote: This information will be validated by validators. Users who do not pass the validation process will be asked to re-submit their details for re-validation.' },
        { id: 2, title: 'Sign Up/ Email Verification', content: 'The email provided in the onboarding template form is verified by sending a one time password(OTP) to the submitted email.' },
        { id: 3, title: 'Sign Up additional details and create password', content: 'This step is divided into personal details registration and company details registration. The details provided in the onboarding templates are pre-filled while the others not provided like company address, phone number and password' },
      ],
    },
    {
      title: 'How to Register as a Governance Plan User',
      state: governanceType,
      setState: setGovernanceType,
      image: SolutionImage2,
      steps: [
        { id: 4, title: 'Ensure the plan aligns with your facility needs', content: 'The governance plan is made for government and private organizations looking to keep track their Nationally Determined Contributions (NDC) and earn from their NDC value.' },
        { id: 5, title: 'Choose a plan, and fill the onboarding template form', content: 'Fill the form by providing your name, email, country, organization governanceType (government or non-government), industry, facility capacity (energy usage), facility category (green, non-green or monitoring), whether you’re a regulator or a non- regulator and your wallet address.\n\nNote: This information will be validated by validators. Users who do not pass the validation process will be asked to re-submit their details for re-validation.' },
        { id: 6, title: 'Sign Up/ Email Verification', content: 'The email provided in the onboarding template form is verified by sending a one time password(OTP) to the submitted email.' },
        { id: 7, title: 'Sign Up additional details and create password', content: 'This step is divided into personal details registration and company details registration. The details provided in the onboarding templates are pre-filled while the others not provided like company address, phone number and password.' },
      ],
    },
    {
      title: 'How to Register as a Verifier Plan User',
      state: verifierType,
      setState: setVerifierType,
      image: SolutionImage3,
      steps: [
        { id: 13, title: 'Ensure the plan aligns with your facility needs', content: 'Whether you’re a beginner in your career or you’re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.' },
        { id: 14, title: 'Choose a plan, and select verification status', content: "Select if you're an accredited verifier with a recognized accrediting body, or choose if you're an individual looking to become a sub-verifier." },
        { id: 15, title: 'For accredited verifiers (CCV)', content: 'Fill the form by providing your name, email, phone number, organisation name, organisation address, organisation email, organisation registration number, and your wallet address.\n\nNote: This information will be validated by validators. Users who do not pass the validation process will be asked to re-submit their details for re-validation.' },
        { id: 16, title: 'Seeking to be a sub verifier (Sub-CCV)', content: "Fill the form with your name, email, phone number, the verification body you're registered with, and your wallet address.\n\nNote: This information will be validated by validators. Users who do not pass the validation process will be asked to re-submit their details for re-validation." },
        { id: 17, title: 'Sign Up/ Email Verification', content: 'The email provided in the onboarding template form is verified by sending a one time password(OTP) to the submitted email.' },
        { id: 18, title: 'Sign Up and create password', content: 'The details provided in the onboarding templates are pre-filled then you create password.' },
      ],
    },
    {
      title: 'How to Register as a Business Plan User',
      state: businessType,
      setState: setBusinessType,
      image: SolutionImage4,
      steps: [
        { id: 8, title: 'Ensure the plan aligns with your facility needs', content: 'The business plan is a paid plan tailored for facilities looking to download their carbon emission report and get carbon monitoring certificate. This plan is also ideal for facilities assigned to a specific sub-ccv (verifier) for their facility.' },
        { id: 9, title: 'Choose a plan, and fill the onboarding template form', content: 'Fill the form by providing your name, email, company name, industry, facility capacity (energy usage), select a sub-ccv (or choose None/Nil), facility category (green or non-green, monitoring), and your wallet address.\n\nNote: This information will be validated by validators. Users who do not pass the validation process will be asked to re-submit their details for re-validation.' },
        { id: 10, title: 'Payment', content: 'If you’re not assigned to a specific sub-ccv, you’ll make a monthly payment of ₦15,995. You can choose between a monthly or yearly subscription, with payments processed through Paystack.' },
        { id: 11, title: 'Sign Up/ Email Verification', content: 'The email provided in the onboarding template form is verified by sending a one time password(OTP) to the submitted email.' },
        { id: 12, title: 'Sign Up additional details and create password', content: 'This step is divided into personal details registration and company details registration. The details provided in the onboarding templates are pre-filled which the others not provided like company address, phone number and password.' },
      ],
    },
    {
      title: 'How to Register as a Business Plus Plan User',
      state: businessPlusType,
      setState: setBusinessPlusType,
      image: SolutionImage5,
      steps: [
        { id: 20, title: 'Ensure the plan aligns with your facility needs', content: 'The business plus plan is a paid plan for facilities that offers powerful tools, for energy sharing and energy efficiency tracking, to help optimize consumption and trade surplus energy. It also include access to downloadable carbon report and official carbon monitoring certificate.' },
        { id: 21, title: 'Choose a plan, and fill the onboarding template form', content: 'Fill the form by providing your name, email address, country, your industry, facility category, and your wallet address.' },
        { id: 22, title: 'Payment', content: 'Payment for the business plus plan is ₦19,995 per month, You can use your preferred payment option either (monthly or yearly).' },
        { id: 23, title: 'Sign Up/ Email Verification', content: 'The email provided in the onboarding template form is then verified by sending a one time password(OTP) to the submitted email.' },
        { id: 24, title: 'Sign Up additional details on the facility', content: 'After signing up user’s are expected to fill a form about their facility information, providing information like the green project, the baseline information and ground truth mapping.' },
      ],
    },
   
    
  ];

   // Sample data for articles
const articles = [
  {
    id: 1,
    // image: 'https://via.placeholder.com/379x282', // replace with actual image
    badgeColor: '#006633',
    badgeText: 'Clean Transport',
    title: 'Netzence set to unveil clean mobility hailing App in June 2026',
    description:
      'At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...',
    source: '25/03/2026',
    link: '/blogpost5' // Example link to the article page
  },
  {
    id: 2,
    // image: 'https://via.placeholder.com/379x282',
    badgeColor: '#7BC216',
    badgeText: 'Sustainable Farming',
    title: 'Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems',
    description:
      'Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...                   ',
    source: '05/02/2026',
    link: '/blogpost3' 
  },
  {
    id: 3,
    // image: 'https://via.placeholder.com/379x282',
    badgeColor: '#006633',
    badgeText: 'Clean Transport',
    title: '2026 Climate Mobility Horizon: Nigeria’s New Income Engine – Netzence',
    description:
      'Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news alerts, but with chronic coughs, shortened lifespans...',
    source: '06/01/2026',
    link: '/blogpost4'
  },
];
const ArticleCard = ({ article }) => {
  const { image, badgeColor, badgeText, title, description, source } = article;
  const [isImageHovered, setIsImageHovered] = useState(false);

  return (
    <div className="w-[379px]  rounded-2xl bg-white shadow-[0_8px_24px_rgba(149,157,165,0.2)] flex flex-col items-center p-0 pb-[24px] gap-4 cursor-pointer transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(0,102,51,0.18)] hover:brightness-105 hover:bg-[#eff9ed]">
      {/* Image */}
      <img
        src={[sus1, sus2, sus3][article.id - 1]} 
        alt={title}
        onMouseEnter={() => setIsImageHovered(true)}
        onMouseLeave={() => setIsImageHovered(false)}
        className="w-full h-[282px] object-cover rounded-t-2xl hover:brightness-75 transition-opacity"
      />

      {/* Content */}
      <div className="w-[352px] flex flex-col items-start gap-4 hover:text-[#60a928] transition-colors">
        {/* Badge */}
        <div
        
          className="px-1.5 py-0.5 rounded text-white text-[14px] font-medium"
          style={{ backgroundColor: badgeColor }}
        >
          <span className="text-[14px] leading-[21px] font-medium ">
            {badgeText}
          </span>
        </div>

        {/* Text container */}
        <div className="w-full flex flex-col items-start gap-3">
          <h3 className=" font-semibold text-[18px] text-[#3B3B3B]">
            {title}
          </h3>
          <p className={`font-normal text-[14px] transition-colors ${isImageHovered ? 'text-green-500' : 'text-[#898989]'}`}>
            {description}
          </p>
        </div>

        {/* Footer */}
        <div className="w-full flex justify-between items-center mt-[16px]">
          <span className=" text-[14px] leading-[21px] text-[#3B3B3B]">
            {source}
          </span>
          <Link to={article.link} className="flex items-center gap-2">
            <span className=" font-medium text-[14px] leading-5 text-[#006633]">
              READ MORE
            </span>
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.57794 6.34668L0.359375 11.3468L1.40294 12.3467L7.14329 6.84662C7.28165 6.71401 7.35938 6.53418 7.35938 6.34668C7.35938 6.15917 7.28165 5.97934 7.14329 5.84674L1.40294 0.34668L0.359375 1.34656L5.57794 6.34668Z" fill="#006633" stroke="#006633" stroke-width="0.5"/>
</svg>

          </Link>
        </div>
      </div>
    </div>
  );
};


  return (
    <>
      <div ref={heroRef} className="relative w-full min-h-[1024px] bg-white overflow-hidden font-sans">
        <Header/>
        {/* Main Content Container */}
    <Section1/>

        {/* Scrolling Marquee (Frame 112) */}
        <div className="absolute md:top-[800px] left-0 w-full h-[90px] overflow-hidden flex items-center bg-white/50 backdrop-blur-sm border-t border-gray-100">
          <div className="flex gap-[36px] animate-marquee whitespace-nowrap" ref={marqueeRef}>
            {seamlessMarquee.map((text, index) => (
              <div key={index} className="flex justify-center items-center px-[18px] py-[12px] h-[80px] border border-[#0D924F] rounded-xl bg-white/80 min-w-max ">
                <span className="font-medium text-[18px] text-[#141414]">
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
          }
          .animate-marquee {
              animation: marquee 60s linear infinite;
          }
          .animate-marquee:hover {
              animation-play-state: paused;
          }
          /* Custom bounce animation for the floating card */
          .animate-bounce-slow {
              animation: bounce-slow 3s infinite;
          }
          @keyframes bounce-slow {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
          }
        `}</style>
      </div>

      {/* section 2 */}
      <section className="relative w-full min-h-[600px] bg-[#FAFAFA] text-[#3B3B3B] font-sans overflow-hidden py-20 z-0">
        {/* Background Decor (Ellipses) - Simplified representation of 'Group 14' */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-[-27px] left-[549px] w-[968px] h-[1024px] opacity-30 hidden lg:block">
            <div className="absolute w-[544px] h-[544px] left-[265px] top-[74px] rounded-full border border-gray-300/60"></div>
            <div className="absolute w-[385px] h-[385px] left-[0px] top-[574px] rounded-full border border-gray-300/60"></div>
            <div className="absolute w-[544px] h-[544px] left-[410px] top-[265px] rounded-full border border-gray-300/60"></div>
            {/* Random dots to match style */}
            <div className="absolute w-[14px] h-[14px] left-[700px] top-[128px] bg-gray-300 rounded-full opacity-50"></div>
            <div className="absolute w-[16px] h-[16px] left-[100px] top-[680px] bg-gray-300 rounded-full opacity-50"></div>
            <div className="absolute w-[16px] h-[16px] left-[400px] top-[400px] bg-gray-300 rounded-full opacity-50"></div>
          </div>
        </div>

        <div className="relative max-w-[1440px] mx-auto px-4 md:px-[120px] flex flex-col lg:flex-row items-center gap-16">
          {/* Left Content (Text) */}
          <div className="flex flex-col items-start gap-8 max-w-[503px] z-0 w-full">
            <div className="flex flex-col gap-4">
              <span className="font-medium text-[24px] md:text-[36px] leading-[43px] text-[#3B3B3B]">
                Our Platform
              </span>
              <h2 className="font-bold text-[48px] md:text-[64px] leading-[76px] text-[#3B3B3B]">
                CloseCarbon
              </h2>
              <p className="font-normal text-[18px] leading-[27px] text-[#3E3838]">
CloseCarbon is an end-to-end digital platform that enables real-time emissions monitoring, transparent verification, and blockchain-backed incentives empowering individuals and organizations to turn climate action into measurable impact.              </p>
            </div>
<div className='flex flex-row gap-5'>
  <div className="w-[75px]  bg-[#E3E3E3] text-[14px] rounded-full text-center p-2  ">Measure</div>
  <div className="w-[75px]  bg-[#E3E3E3] text-[14px] rounded-full text-center p-2  ">Verify</div>
  <div className="w-[75px]  bg-[#E3E3E3] text-[14px] rounded-full text-center p-2  ">Reduce</div>
  <div className="w-[75px]  bg-[#E3E3E3] text-[14px] rounded-full text-center p-2  ">Incentive</div>

</div>   <button
                type="button"
                onClick={() => document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' })}
                className="hero-btn group flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[193px]  h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] cursor-pointer  "
              >
                <span className="font-medium text-[24px] text-white text-center">
                  Get Started
                </span>
              </button>
          </div>

          {/* Right Content (Dashboard Mockup) - "Existing user" */}
          <div className="animate-float relative w-[800px] flex items-center justify-center origin-center">
            <img  src={dash} alt="" />
          </div>
        </div>
      </section>

      {/* section 3 */}
      <OurImpact/>
   

      {/* section 4 (services) - unchanged */}

<OurService />
      {/* section 5 (tabbed plans) - unchanged */}
<Plans/>

      <Collaborators />

      {/* ----- Step-by-Step Guide with Stack Scroll Effect ----- */}
      <div className="home z-0">
        <div className="step-by-step">
          <hr className="text-slate-600 w-full" />

          <div className="step-by-step__header">
            <div className="step-by-step__header__inner">
              <div className="step-by-step__header__inner__nav">
                
                <div
                  className={activeSection === "subscription" ? "step-by-step__header__inner__nav__active" : ""}
                  onClick={() => scrollToSection("subscription")}
                >
                  <div className="text-[16px]">Subscription Plans</div>
                  <div></div>
                </div>
                <div
                  className={activeSection === "wallet" ? "step-by-step__header__inner__nav__active z-0" : ""}
                  onClick={() => scrollToSection("wallet")}
                >
                  <div className="text-[16px]" >Create Metamask wallet</div>
                  <div></div>
                </div>
                <div
                  className={activeSection === "exchange" ? "step-by-step__header__inner__nav__active" : ""}
                               onClick={() => document.getElementById('ExchangeToCCRT')?.scrollIntoView({ behavior: 'smooth' })}

                >
                  <div className="text-[16px]">Exchange CCRT to USDT</div>
                  <div></div>
                </div>
                <div
                  className={activeSection === "iot" ? "step-by-step__header__inner__nav__active" : ""}
                                             onClick={() => document.getElementById('IOT')?.scrollIntoView({ behavior: 'smooth' })}

                >
                  <div className="text-[16px]">IoT device</div>
                  <div></div>
                </div>
                <div
                onClick={(e) => {
              e.preventDefault();
              document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' });
            }}
                  className={activeSection === "plans" ? "step-by-step__header__inner__nav__active" : ""}
                >
                  <div className="text-[16px]">Get Started</div>
                  <div></div>
                </div>
              </div>
              <button
                type="button"
                onClick={() => document.getElementById('plans')?.scrollIntoView({ behavior: 'smooth' })}
                className="h-[54px] w-[253px]"
              >
                See plans and pricings
              </button>
            </div>
          </div>
          <hr className="text-slate-600 w-full" />

          <div
            className="step-by-step__inner step-by-step__inner-grey"
            id="step-by-step-subscription"
            ref={sectionRefs.subscription}
          >
            <div className="step-by-step__inner__guard">
              <div className="step-by-step__inner__title">Step-by-Step Guide</div>
              <div className="step-by-step__inner__subtitle">Subscription Plans</div>
              <div className="step-by-step__inner__subsubtitle">
                You can choose from our Basic, Governance, Business or Verifiers
                subscription plans to get started with CloseCarbon.
              </div>

              {/* Stack scroll cards */}
              {planSections.map((plan, index) => (
                <div
                id={plan.id}
                  key={index}
                  className="step-by-step__inner__grid sticky top-0 bg-white  rounded-lg p-6 mb-6 z-0"
                  style={{ zIndex: 0 + index }} // higher index appears on top when stacked
                >
                  <div className="step-by-step__inner__grid__nav">
                    <div className="step-by-step__inner__grid__nav__title">

                      {plan.title}
                    </div>

                    {plan.steps.map((step) => (
                      <div
                        key={step.id}
                        className={
                          plan.state === step.id
                            ? "step-by-step__inner__grid__nav__item step-by-step__inner__grid__nav__item-active cursor-pointer border-l-4 border-green-500 pl-4 mb-3"
                            : "step-by-step__inner__grid__nav__item cursor-pointer pl-4 mb-3"
                        }
                        onClick={() => plan.setState(step.id)}
                      >
                        <div className="step-by-step__inner__grid__nav__item__title">
                          {step.title}
          <hr className="text-[#B1B1B1] w-full" />

                        </div>
                        {plan.state === step.id && (
                          <div className="step-by-step__inner__grid__nav__item__subtitle mt-2 text-gray-600 whitespace-pre-line">
                            {step.content}
                            
                          </div>
                          
                          
                        )}
                      </div>
                      
                    ))}

                  </div>

                  {/* Show image if any step of this plan is active */}
                  {plan.steps.some(step => step.id === plan.state) && (
                    <img
                      src={plan.image}
                      className="step-by-step__inner__grid__img mt-6 rounded-lg"
                      alt={plan.title}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Other step-by-step sections (wallet, exchange, etc.) remain empty for now */}
          <div
            className="step-by-step__inner"
            id="step-by-step-wallet"
            ref={sectionRefs.wallet}
          >
            {/* Content for wallet can be added later */}
          </div>
        </div>
      </div>

      {/* section 6 placeholder */}
       <section className="relative w-[1440px] h-[1578px] bg-white flex flex-col justify-center items-center p-[120px] gap-8 overflow-hidden mx-auto">
      {/* Background decorative ellipses */}
      {/* <div className="absolute w-[1237.3px] h-[1237.3px] left-[-296px] top-[-232px] bg-gradient-to-br from-[rgba(198,232,215,0.2)] via-[rgba(22,162,89,0.2)] to-[rgba(5,102,53,0.2)] rounded-full pointer-events-none" />
      <div className="absolute w-[529.82px] h-[529.82px] left-[78.36px] top-[649.97px] bg-gradient-to-br from-[rgba(198,232,215,0.2)] via-[rgba(22,162,89,0.2)] to-[rgba(5,102,53,0.2)] rounded-full pointer-events-none" />
      <div className="absolute w-[529.82px] h-[529.82px] left-[608.18px] top-[193.12px] bg-gradient-to-br from-[rgba(198,232,215,0.2)] via-[rgba(22,162,89,0.2)] to-[rgba(5,102,53,0.2)] rounded-full pointer-events-none" /> */}

      {/* Title & Description */}
      <div className="w-[720px] h-[109px] flex flex-col justify-center items-center gap-3 z-0">
        <h1 className=" font-bold text-[36px] leading-[43px] text-[#3B3B3B] text-center">
          Create Metamask Wallet
        </h1>
        <p className="  text-[18px] w-[800px] text-[#3B3B3B] text-center mb-20">
          MetaMask is a cryptocurrency wallet and gateway to blockchain
          applications. This guide will walk you through the process of
          creating and securing your MetaMask account.
        </p>
      </div>

      {/* Main steps container */}
      <div className="w-[1200px] h-[1197px] flex flex-col items-start gap-5 z-0">
        {/* Two columns row (steps 1-4) */}
        <div className="flex flex-row items-start gap-[33px] w-full h-[868px]">
          {/* Left column (Step 1 & 2) */}
          <div className="w-[583.5px] h-[868px] flex flex-col gap-5">
            {/* Step 1 card */}
            <div className="relative w-full h-[424px] bg-[rgba(231,246,236,0.48)] rounded-2xl">
              <div className="absolute left-10 top-1/2 -translate-y-1/2 w-[420px] h-[223px] flex flex-col gap-[23px]">
                {/* Image placeholder */}
                <img src={search}></img>
                {/* Step 1 text */}
                <div className="w-full h-[152px] flex flex-col gap-[11px]">
                  <h2 className="text-[#141414] text-[24px] font-medium leading-[29px]">
                    Step 1: Install MetaMask Extension
                  </h2>
                  <div className="flex flex-col gap-3">
                    <p className="text-[#898989] text-[16px] font-medium">
                      Visit the official MetaMask website (metamask.io)
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Click &quot;Download&quot; and choose your browser
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Click &quot;Add to Browser&quot; or &quot;Install&quot;
                    </p>
                    <p className="text-[#898989] text-[16px] font-medium">
                      Pin the extension to your browser toolbar for easy access
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Step 2 card */}
            <div className="w-full h-[424px] bg-[rgba(20,149,84,0.05)] rounded-2xl p-[60px_40px] flex flex-col gap-6">
              {/* Icon placeholder */}
                      <div className="w-[100px] h-[100px]  rounded flex items-center justify-center text-xs ">

              <img src={wallet}></img>
              </div>
              <div className="w-full flex flex-col gap-4">
                <h2 className="text-[#141414] text-[24px] font-medium leading-[29px]">
                  Step 2: Create a New Wallet
                </h2>
                <div className="flex flex-col gap-3">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click the MetaMask icon in your browser
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Get Started&quot;
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Select &quot;Create a New Wallet&quot;
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Create a strong password
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right column (Step 3 & 4) */}
          <div className="w-[583.5px] h-[868px] flex flex-col gap-5">
            {/* Step 3 card */}
            <div className="w-full h-[448px] bg-[#F7FBF4] rounded-2xl p-[60px_40px] flex flex-col gap-[23px]">
              {/* Icon placeholder */}
                      <div className="w-[100px] h-[100px]  rounded flex items-center justify-center text-xs ">
     <img src={seed}></img>
                      </div>
              
              <div className="w-full flex flex-col ">
                <h2 className="text-[#141414] text-[24px] font-medium ">
                  Step 3: Secret Recovery Phrase
                </h2>
                <div className="flex flex-col ">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Next&quot; to reveal your 12-word Secret
                    Recovery Phrase
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Important security tips
                  </p>

                  
                  <p className="text-[#898989] text-[14px] mb-3 leading-[-7px] -gap-6">
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'>Write down the phrase on paper (never digitally)</div><br/>

                    </div>
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'>Write words in exact order</div><br/>

                    </div>
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'>Double-check spelling</div><br/>

                    </div>
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'> Store in a secure, private location</div><br/>

                    </div>
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'>Never share with anyone</div><br/>

                    </div>
                    <div className='flex    '>
                 <div className='text-3xl font-extrabold mr-2 '>.</div>  <div className='text-[14px]  mt-2'>MetaMask support will never ask for this phrase</div><br/>

                    </div>
                    

                  </p>
                </div>
              </div>
            </div>

            {/* Step 4 card */}
            <div className="w-full h-[400px] bg-[#F7FBF4] rounded-2xl p-[60px_40px] flex flex-col gap-[23px]">
              {/* Icon placeholder */}
              <div className="w-[100px] h-[100px]  rounded flex items-center justify-center text-xs ">
                <img src={dollar}></img>
              </div>
              <div className="w-full flex flex-col gap-4">
                <h2 className="text-[#141414] text-[24px] font-medium leading-[29px]">
                  Step 4: Verify Recovery Phrase
                </h2>
                <div className="flex flex-col gap-3">
                  <p className="text-[#898989] text-[16px] font-medium">
                    Select each word in the correct order when prompted
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Click &quot;Confirm&quot; to complete verification
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    You&apos;ll see a &quot;Congratulations&quot; message upon
                    successful completion
                  </p>
                  <p className="text-[#898989] text-[16px] font-medium">
                    Sign Up and create password
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Step 5 full-width card */}
        <div className="w-full h-[309px] bg-[#F4FBF6] rounded-2xl p-[60px_40px] flex flex-col gap-[23px]">
          <div className="flex flex-row items-center gap-[23px] w-[1120px] h-[189px]">
            {/* Fox icon placeholder */}
            <div className="w-[100px] h-[96.39px]  rounded flex items-center justify-center text-xs ">
         <img src={metaMake}></img>

            </div>
            {/* Step 5 text */}
            <div className="flex-1 flex flex-col gap-4">
              <h2 className="text-[#141414] text-[24px] font-medium leading-[29px]">
                Step 5: Account Security
              </h2>
              <div className="flex flex-col gap-3">
                <p className="text-[#898989] text-[16px] font-medium">
                  Go to Settings &gt; Security &amp; Privacy
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Enable auto-lock feature
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Set a reasonable timeout period
                </p>
                <p className="text-[#898989] text-[16px] font-medium">
                  Consider enabling enhanced privacy settings
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* section 7 */}


     <section id="ExchangeToCCRT" className="max-auto w-[1440px] h-[780px] bg-white flex flex-col items-start p-30 gap-2.5 mx-auto overflow-hidden p-[120px]">
      <div className="w-[1200px] h-[540px] flex flex-col items-start gap-12">
        {/* Header */}
        <div className="w-[546px] flex flex-col gap-4">
          <h1 className=" font-bold text-[40px] leading-[120%] tracking-[-0.04em] text-[#3B3B3B]">
            Exchange <span className='text-[#0D924F]'>CCRT </span>to USDT
          </h1>
          <p className=" font-normal text-[18px] leading-[145%] text-[#3B3B3B]">
            Convert your carbon credits to liquidity seamlessly. This is done on the polygon network using Uniswap.
          </p>
        </div>

        {/* Cards row */}
        <div className="flex flex-row items-center gap-6 w-full h-[376px] ">
          {cards.map((card) => (
            <div
              key={card.id}
              className="relative w-[282px] h-[376px] bg-[#FAFAFA] rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
            >
              <img className='object-cover' src={card.image}></img>
              {/* Image area */}
              {/* <div className="absolute top-0 left-0 w-full h-[180px] bg-gray-300 flex items-center justify-center text-gray-600 text-sm">
                {card.image}
              </div>  */}

              {/* Text content */}
               <div className="absolute left-3 top-[196px] w-[calc(100%-24px)] flex flex-col gap-4">
                <h2 className="font-medium text-[24px] leading-[29px] text-[#141414]">
                  {card.title}
                </h2>
                <div className="flex flex-col gap-2">
                  {card.bullets.map((bullet, idx) => (
                    <p
                      key={idx}
                      className="font-medium text-[16px] leading-[19px] text-[#898989]"
                    >
                      {bullet}
                    </p>
                  ))}
                </div>
              </div>
            </div> 
           ))} 
         </div> 
      </div>
    </section>

    {/* section 8 */}
      <section id="IOT" className="w-full h-[1273px] flex flex-col items-center pb-30 gap-12 mx-auto overflow-hidden">
      {/* Top hero with background image */}
      <div
        className="w-full h-[731px] relative bg-cover bg-center"
        style={{
          backgroundImage:`url(${iot})`,
        }}
      >
        {/* Text overlay */}
        
      </div>

      {/* Bottom cards section */}
      <div className="w-full flex justify-center items-center">
        <div className="w-[1200px] flex flex-row gap-12">
          {/* Data Collection Card (left) */}
          <div className="w-[576px] h-[374px] bg-[#F7F9FC] rounded-2xl p-6 pl-8 flex flex-col gap-6 transition-opacity hover:border-green-300 hover:border-2 duration-300 hover:bg-white">
            {/* Icon */}
            <svg width="115" height="115" viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_5840_17241)">
<rect x="31.4141" y="23.833" width="52" height="52" rx="13" fill="#40B869"/>
<path d="M68.7891 49.8322C68.7891 51.9265 63.6956 53.6239 57.4141 53.6239C51.1325 53.6239 46.0391 51.9265 46.0391 49.8322M68.7891 49.8322V58.6795C68.7891 60.7737 63.6956 62.4711 57.4141 62.4711C51.1325 62.4711 46.0391 60.7737 46.0391 58.6795V49.8322M68.7891 49.8322V40.985M46.0391 49.8322V40.985M68.7891 40.985C68.7891 43.0793 63.6956 44.7767 57.4141 44.7767C51.1325 44.7767 46.0391 43.0793 46.0391 40.985M68.7891 40.985C68.7891 38.8908 63.6956 37.1934 57.4141 37.1934C51.1325 37.1934 46.0391 38.8908 46.0391 40.985" stroke="#E7F6EC" stroke-width="2.52778"/>
</g>
<defs>
<filter id="filter0_d_5840_17241" x="-0.00260544" y="-0.000326633" width="114.833" height="114.833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="7.58333"/>
<feGaussianBlur stdDeviation="15.7083"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0 0.435294 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5840_17241"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5840_17241" result="shape"/>
</filter>
</defs>
</svg>

            {/* Title */}
            <h2 className=" font-semibold text-[20px] leading-[120%] tracking-[-0.02em] text-black ">
              Data Collection
            </h2>
            {/* Green facilities */}
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4">
                <span className="font-medium text-[16px] text-[#0D924F]">
                  GREEN FACILITIES
                </span>
                <p className="font-normal text-[16px] text-[#475367]">
                  Autonomous measurement of emissions from renewable energy
                  sources.
                </p>
              </div>
              {/* Separator */}
              <div className="w-full border-t border-[#E4E7EC]" />
              {/* Non-green facilities */}
              <div className="flex flex-col gap-4">
                <span className="font-medium text-[16px] text-[#667185]">
                  NON-GREEN FACILITIES
                </span>
                <p className="font-normal text-[16px] text-[#475367]">
                  Meticulous quantification of emission from non-renewable
                  sources.
                </p>
              </div>
            </div>
          </div>

          {/* Data Security & Integrity Card (right) */}
          <div className="w-[576px] h-[374px] bg-[#F7F9FC] rounded-2xl p-6  flex flex-col gap-6  hover:border-[#1671D9] hover:border-2 duration-300 hover:bg-white">
            <div className=" font-semibold text-[20px] leading-[120%] tracking-[-0.02em] text-black">
            {/* Icon */}
           <svg width="115" height="115" viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_5840_17225)">
<rect x="31.4141" y="23.833" width="52" height="52" rx="13" fill="#1671D9"/>
<path d="M65.8935 39.0829C63.5022 37.8936 60.5738 37.1934 57.4141 37.1934C54.2543 37.1934 51.3272 37.8936 48.9346 39.0829C47.7617 39.6668 47.1753 39.9587 46.6078 40.8763C46.0403 41.7939 46.0391 42.6812 46.0391 44.4582V48.8692C46.0391 56.0518 51.7796 60.0445 55.1049 61.7558C56.0326 62.2323 56.4952 62.4711 57.4141 62.4711C58.3329 62.4711 58.7955 62.2323 59.7232 61.7558C63.0472 60.0445 68.7891 56.0506 68.7891 48.8679V44.4582C68.7891 42.6812 68.7891 41.7939 68.2203 40.8763C67.6516 39.9587 67.0664 39.6668 65.8935 39.0829Z" stroke="#E3EFFC" stroke-width="1.89583" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M54.8802 47.3045V45.4086C54.8802 44.7382 55.1465 44.0953 55.6206 43.6212C56.0946 43.1472 56.7376 42.8809 57.408 42.8809C58.0784 42.8809 58.7213 43.1472 59.1954 43.6212C59.6694 44.0953 59.9358 44.7382 59.9358 45.4086V47.3045M54.8802 47.3045H59.9358M54.8802 47.3045C54.3774 47.3045 53.8952 47.5042 53.5397 47.8597C53.1841 48.2153 52.9844 48.6975 52.9844 49.2003V51.0961C52.9844 51.5989 53.1841 52.0812 53.5397 52.4367C53.8952 52.7922 54.3774 52.992 54.8802 52.992H59.9358C60.4386 52.992 60.9208 52.7922 61.2763 52.4367C61.6319 52.0812 61.8316 51.5989 61.8316 51.0961V49.2003C61.8316 48.6975 61.6319 48.2153 61.2763 47.8597C60.9208 47.5042 60.4386 47.3045 59.9358 47.3045" stroke="#E3EFFC" stroke-width="1.89583" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_5840_17225" x="-0.00260544" y="-0.000326633" width="114.833" height="114.833" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="7.58333"/>
<feGaussianBlur stdDeviation="15.7083"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.392157 0 0 0 0 0.392157 0 0 0 0 0.435294 0 0 0 0.2 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5840_17225"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5840_17225" result="shape"/>
</filter>
</defs>
</svg></div>

            {/* Title */}
            <h2 className=" font-semibold text-[20px] leading-[120%] tracking-[-0.02em] text-black ">
              Data Security & Integrity
            </h2>
            {/* Description */}
            <p className="font-normal text-[16px] text-[#475367]">
              Ensures the integrity of collected emissions data for accurate
              reporting and analysis.
            </p>
            {/* Sub-card */}
            <div className="flex flex-row items-start gap-4 p-3 h-[93px] bg-white border border-[#E3EFFC] rounded-xl">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="8" fill="#E3EFFC"/>
<g clip-path="url(#clip0_5840_17235)">
<path d="M10.5225 20.2822H7.92857V12.5705H10.1561C10.4118 12.5705 10.6571 12.4351 10.8379 12.1941C11.0188 11.9531 11.1204 11.6261 11.1204 11.2853C11.1204 10.9444 11.0188 10.6175 10.8379 10.3764C10.6571 10.1354 10.4118 10 10.1561 10H7.92857C7.41708 10 6.92654 10.2708 6.56487 10.7529C6.20319 11.235 6 11.8888 6 12.5705V20.2822C6 20.9639 6.20319 21.6177 6.56487 22.0998C6.92654 22.5819 7.41708 22.8527 7.92857 22.8527H10.5225C10.7782 22.8527 11.0235 22.7173 11.2044 22.4763C11.3852 22.2352 11.4868 21.9083 11.4868 21.5674C11.4868 21.2266 11.3852 20.8997 11.2044 20.6586C11.0235 20.4176 10.7782 20.2822 10.5225 20.2822ZM17.4654 16.9919C17.4901 16.9174 17.5095 16.8399 17.5232 16.7605C17.5278 16.675 17.5278 16.589 17.5232 16.5035V16.2721C17.5167 16.1837 17.5005 16.0971 17.475 16.0151C17.4545 15.9392 17.4287 15.866 17.3979 15.7966C17.3706 15.7241 17.3384 15.6553 17.3014 15.5909L17.1471 15.4238L17.0604 15.3082H17.0025L16.8289 15.2311H13.4539L14.8521 12.0179C14.98 11.7213 15.0143 11.3692 14.9474 11.039C14.8804 10.7088 14.7179 10.4275 14.4954 10.2571C14.2729 10.0866 14.0087 10.041 13.7609 10.1302C13.5132 10.2193 13.3022 10.436 13.1743 10.7326L10.9468 15.8737V15.9508C10.922 16.0253 10.9027 16.1028 10.8889 16.1822C10.8843 16.2677 10.8843 16.3536 10.8889 16.4392L10.8214 16.4264V16.5806C10.8279 16.669 10.8441 16.7556 10.8696 16.8376C10.8902 16.9135 10.916 16.9867 10.9468 17.0561C10.974 17.1286 11.0063 17.1974 11.0432 17.2618L11.1975 17.4289C11.2246 17.4698 11.2535 17.5085 11.2843 17.5445H11.4386C11.5451 17.6295 11.663 17.6862 11.7857 17.7116H14.9389L13.5407 20.9248C13.4128 21.2214 13.3786 21.5735 13.4455 21.9037C13.5124 22.2339 13.675 22.5152 13.8975 22.6856C14.12 22.8561 14.3842 22.9017 14.6319 22.8125C14.8797 22.7233 15.0907 22.5066 15.2186 22.2101L17.4461 17.069C17.4461 17.069 17.4557 17.0176 17.4654 16.9919ZM24.3214 13.8558C24.0657 13.8558 23.8204 13.9912 23.6396 14.2323C23.4587 14.4733 23.3571 14.8002 23.3571 15.1411V17.7116C23.3571 18.0525 23.4587 18.3794 23.6396 18.6205C23.8204 18.8615 24.0657 18.9969 24.3214 18.9969C24.5772 18.9969 24.8224 18.8615 25.0033 18.6205C25.1841 18.3794 25.2857 18.0525 25.2857 17.7116V15.1411C25.2857 14.8002 25.1841 14.4733 25.0033 14.2323C24.8224 13.9912 24.5772 13.8558 24.3214 13.8558ZM20.4643 10H17.8704C17.6146 10 17.3693 10.1354 17.1885 10.3764C17.0077 10.6175 16.9061 10.9444 16.9061 11.2853C16.9061 11.6261 17.0077 11.9531 17.1885 12.1941C17.3693 12.4351 17.6146 12.5705 17.8704 12.5705H20.4643V20.2822H18.2368C17.981 20.2822 17.7358 20.4176 17.5549 20.6586C17.3741 20.8997 17.2725 21.2266 17.2725 21.5674C17.2725 21.9083 17.3741 22.2352 17.5549 22.4763C17.7358 22.7173 17.981 22.8527 18.2368 22.8527H20.4643C20.9758 22.8527 21.4663 22.5819 21.828 22.0998C22.1897 21.6177 22.3929 20.9639 22.3929 20.2822V12.5705C22.3929 11.8888 22.1897 11.235 21.828 10.7529C21.4663 10.2708 20.9758 10 20.4643 10Z" fill="#1671D9" stroke="#E3EFFC" stroke-width="0.428571"/>
</g>
<defs>
<clipPath id="clip0_5840_17235">
<rect width="20" height="20" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>

              <div className="flex flex-col gap-2">
                <span className=" font-semibold text-[16px] text-black">
                  Stable operation
                </span>
                <p className="font-normal text-[12px] leading-[160%] tracking-[0.01em] text-[#475367]">
                  Battery banks provide backup power to maintain uninterrupted
                  operation, ensuring data continuity even during power outages.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* section 9 */}
     <section className="w-full h-[1204px] bg-[#E7F6EC] flex flex-col items-start p-30 gap-2.5  overflow-hidden">
      <div className="max-w-full flex flex-col gap-12  mx-auto  pt-44">
        {/* Header */}
        <div className="flex flex-col gap-3">
          <h2 className=" font-bold text-[36px]  text-[#3B3B3B]">
            Get Started
          </h2>
          <p className=" font-normal text-[18px]  text-[#3B3B3B]">
            Take the bold step today!
          </p>
        </div>

        {/* Two columns */}
        <div className="flex flex-row items-center gap-6  align-self-center max-w-auto justify-center">
          {/* Left column - 3 cards */}
          <div className="w-[757px] flex flex-col gap-6">
            {leftPlans.map((plan, idx) => (
              <div
                key={idx}
                className="w-full max-h-[262px] bg-white rounded-2xl p-6 flex flex-col gap-2.5"
              >
                {/* Hidden MetaMask icon placeholder - ignored */}
                {/* Content container */}
                <div className="w-full flex flex-col gap-6">
                  {/* Logo */}
                  <div className="w-10 h-10 relative">
                    <div className='bg-[#006633]/10 rounded-xl w-[40px] h-[40px] p-3 mb-5'>
                      

    <img className=' ' src={CloseCarbon_logo2}></img>
    </div>
                  </div>
                  {/* Text and button */}
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-3">
                      <h3 className=" font-medium text-[24px] leading-[29px] text-[#141414] mt-10">
                        {plan.title}
                      </h3>
                      <p className="font-medium text-[16px] text-[#898989]">
                        {plan.description}
                      </p>
                    </div>
                    {/* Button */}
                    <Link to={plan.link} className="flex flex-row justify-center items-center px-[18px] py-3 gap-2.5 w-[132px] h-[47px] bg-[#0D924F] hover:bg-[#097B42] border-2 border-[#E4E7EC] rounded-[8px]">
                      <span className=" font-medium text-[14px]  text-white rounded-[8px] ">
                        Choose plan
                      </span>
                    </Link>

                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right column - 2 cards */}
          <div className="w-[419px] flex flex-col gap-[16px]">
            {rightPlans.map((plan, idx) => (
              <div
                key={idx}
                className="w-full max-h-[450px] bg-white rounded-2xl p-[25px_25px]  pb-5 flex flex-col gap-2.5"
              >
                <div className="w-full flex flex-col ">
                  {/* Logo */}
                  <div className="w-10 h-10 relative">
                     <div className='bg-[#006633]/10 rounded-xl w-[40px] h-[40px] '>
                      

    <img className=' ' src={CloseCarbon_logo2}></img>
    </div>
                  </div>
                  {/* Text and button */}
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-3">
                      <h3 className=" font-medium text-[24px] text-[#141414] mt-10">
                        {plan.title}
                      </h3>
                      <p className="font-medium text-[16px] text-[#898989]">
                        {plan.description}
                      </p>
                    </div>
                    {/* Button */}
                    <Link to={plan.link} className="flex mb-3 flex-row justify-center items-center px-[18px] py-3 gap-2.5 w-[132px] h-[47px] bg-[#0D924F] hover:bg-[#097B42] border-2 border-[#E4E7EC] rounded-lg">
                      <span className=" font-medium text-[14px]  text-white">
                        Choose plan
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    {/* section 10 */}
    <section className='home'>
          <div className="how">
        <div className="title">
          How CloseCarbon Platform <span>Works</span>
        </div>
        <div className="subtitle">
          Users can actively monitor their carbon footprint in real-time,
          leveraging validated data by verified third parties. <br /> The
          platform incentivises eco-friendly practices through carbon incentive
          programs, encouraging individuals and <br /> businesses to contribute
          to global environmental efforts.{" "}
          <span>Watch the video below to learn more</span>
        </div>
        <div className="play">
          {!howPlaying && (
            <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="pointer"
              onClick={() => setHowPlaying(true)}
            >
              <circle
                cx="50"
                cy="50"
                r="48.5"
                fill="white"
                stroke="#0D924F"
                stroke-width="3"
              />
              <path
                d="M42.312 61.5001C41.9282 61.4994 41.5513 61.3988 41.2182 61.2082C40.4682 60.7832 40.002 59.9582 40.002 59.0626V40.9376C40.002 40.0395 40.4682 39.217 41.2182 38.792C41.5592 38.596 41.9466 38.4952 42.3399 38.5002C42.7331 38.5051 43.1179 38.6156 43.4538 38.8201L58.9445 48.0926C59.2673 48.295 59.5334 48.5761 59.7179 48.9096C59.9024 49.243 59.9992 49.6178 59.9992 49.9989C59.9992 50.3799 59.9024 50.7547 59.7179 51.0882C59.5334 51.4216 59.2673 51.7027 58.9445 51.9051L43.4513 61.1801C43.1075 61.388 42.7137 61.4986 42.312 61.5001Z"
                fill="#0FA958"
              />
            </svg>
          )}
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/ppPfMr0nerY?autoplay=${howPlaying ? 1 : 0
              }`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>

<Link to="#subscription" className="flex flex-row justify-center items-center  py-3 gap-2.5 w-[193px] h-[61px] bg-[#0D924F] rounded-[8px] text-white text-center  justify-self-center"  >
        <div
          onClick={() => {
            navigate("#subscription");
          }}
          className='text-[24px] bg-[#0D924F] hover:bg-[#005528] border-[#E4E7EC] border-2 rounded-[8px] text-white text-center w-[193px] h-[61px] items-center  justify-self-center py-4 cursor-pointer'
        >
          Get started
         
        </div>
</Link>

      </div>
    </section>

    {/* section 11 */}
    <section className="relative  h-[875px] bg-[#101928] mx-auto overflow-hidden">
      {/* Header */}
      <div className="absolute left-1/2 -translate-x-1/2 top-16 w-[717px] flex flex-col items-center gap-4">
        <h2 className=" font-semibold text-[40px] leading-[120%] tracking-[-0.04em] text-white text-center">
        Partner <span className='text-[#0D924F]'>Spotlight </span> 
        </h2>
        <p className=" text-[18px] leading-[21px] text-center text-[#898989] max-w-[603px]">
         Strategic insights for the carbon economy, paired with vetted partners driving real-world sustainability impact.
        </p>
      </div>

      {/* Left content */}
      <div className="absolute left-[120px] top-[280px] w-[499px] flex flex-col gap-10">
        <div className="flex flex-col gap-6">
          <h1 className=" font-semibold text-[48px] leading-[110%] tracking-[-0.04em] text-white">
          Introducing Low-cost mobility for Nigeria’s transport system - Netzence
          </h1>
          <p className=" font-normal text-[20px] leading-[120%] tracking-[-0.02em] text-[#898989]">
           Nigeria’s mobility ecosystem is shifting. Rising fuel prices and congestion have made transportation costs unsustainable for many commuters.
          </p>
          {/* Tags */}
          <div className="flex flex-row items-center gap-3">
            <div className="bg-white/5 border border-[#141414] rounded-full py-2 px-4">
              <span className=" text-sm text-[#B1B1B1]">
         Clean Transport
              </span>
            </div>
            <div className="bg-white/5 border border-[#141414] rounded-full py-2 px-4">
              <span className=" text-sm text-[#B1B1B1]">
               Nigeria-Wide Support
              </span>
            </div>
          </div>
        </div>
        {/* Button */}
        <Link to="/PressAndNews" className="flex flex-row justify-center items-center mt-5 py-3 gap-2.5 w-[147px] h-[47px] bg-[#0D924F] border-2 border-[#006633] hover:bg-[#0b7c43] rounded-lg">
          <span className=" font-medium text-[16px] text-white">
Discover more
          </span>
        </Link >
      </div>

      {/* Right image */}
      <div
        className="absolute left-[725.58px] top-[242px] w-[815.42px] h-[541px] rounded-l-[26.882px] bg-cover bg-center"
        style={{
          backgroundImage:`url(${solar1})`,
        }}
      />
    </section>
    {/* section 13 */}
     <section className="w-[1201px] h-[938px]  flex flex-col items-start gap-12 max-w-auto mx-auto  overflow-hidden mt-44 ">
      {/* Header row */}
      <div className="w-full  flex items-center justify-between">
        {/* Left: title and description */}
        <div className="w-[717px] flex flex-col gap-4">
          <h2 className=" font-bold text-[36px]  text-[#3B3B3B] mt-5">
Stay Informed on Sustainable <span className='text-[#0D924F]'>Initiatives</span>.       </h2>
          <p className="  text-[18px] text-[#3B3B3B]">
Get access to top latest news on sustainability, carbon emission, carbon reduction and lots more.           </p>
        </div>

        {/* Right: button */}
        <Link to="/blogs" className="w-[117px] h-[47px] border-2 border-[#006633] rounded-xl flex items-center justify-center hover:bg-[#006633] hover:text-white  py-3 gap-2.5">
          <span className=" font-medium text-[16px] text-[#006633] hover:text-white">
View more         </span>
          {/* Arrow is hidden in design */}
          <span className="hidden">→</span>
        </Link>
      </div>

      {/* Articles row */}
      <div className="w-full flex items-center gap-8 max-auto justify-center ">
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} image={article.image}/>
        ))}
      </div>
    </section>

    {/* section 12 */}

<ExploreLeading/>


    {/* section 13 */}
        <section className="relative w-[1200px] h-[410px] mx-auto rounded-xl overflow-hidden">
      {/* Gradient background with overlay */}


      {/* Background pattern image (flipped) */}
      <div
        className="  w-[1200px] h-[410px]  bg-cover bg-center"
        style={{
          backgroundImage:
            `url(${messionBg})`,
        }}
      />

      {/* Main content */}
      <div className="absolute left-[63.5px] top-1/2 -translate-y-1/2 w-[1063px] flex flex-row items-end justify-between">
        {/* Left column */}
        <div className="w-[476px] flex flex-col gap-20">
          <div className="flex flex-col gap-6">
            <h2 className="font-medium text-[48px] leading-[100%]  text-white">
              Join the Mission for Zero Emissions.
            </h2>
            <p className="text-[18px] text-[#FAFAFA] mb-10">
              Subscribe to receive intelligence reports on carbon markets,
              regulatory updates from Nigeria, and technical insights from the
              CloseCarbon ecosystem.
            </p>
          </div>
        </div>

        {/* Right column */}
        <div className="w-[399px] flex flex-col gap-6">
          {/* Email input */}
          <div className="flex flex-row items-center gap-2.5 w-full h-[58px] px-8 py-4 bg-[rgba(137,137,137,0.7)] border border-white rounded-lg">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-[#E4E7EC]"
            >
              <path
                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 6L12 13L2 6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter you email address"
              className="w-full bg-transparent text-white placeholder-[#E4E7EC]  font-medium text-[14px] outline-none"
            />
          </div>

          {/* Subscribe button */}
          <button
            onClick={handleSubscribe}
            className="flex flex-row justify-center items-center w-full h-[61px] px-8 py-4 bg-white border border-[#E4E7EC] rounded-lg"
          >
            <span className=" font-medium text-3xl leading-[120%] tracking-[-0.02em] text-[#0D924F]">
Subscribe to our newsletter            </span>
          </button>
        </div>
      </div>

      {/* Footer note */}
      <p className="absolute left-[64px] bottom-[49px] text-sm leading-[17px] text-[#FAFAFA]">
       By joining, you agree to our data integrity standards and environmental protocols.
      </p>
    </section>

{/* section 14 */}
      <section className="w-[758px] mx-auto flex flex-col items-center gap-8 py-12 mt-40 mb-40">
      <h2 className=" font-medium text-[48px] leading-[100%] tracking-[-0.04em] text-[#141414] text-center">
        Frequently Asked <span className='text-[#0D924F]'>Questions </span>
      </h2>

      <div className="w-full flex flex-col gap-3">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className={`w-full bg-white rounded-xl transition-all duration-300 ease-in-out p-[25px] ${
                isOpen
                  ? "border-[0.8px] border-[rgba(13,146,79,0.3)]"
                  : "border border-[rgba(13,146,79,0.3)]"
              }`}
              style={{
                height: isOpen ? "140px" : "90px",
                overflow: "hidden",
              }}
            >
              {/* Header row (icon + question + chevron) */}
              <div className="flex items-center gap-[10px] w-full">
                {/* Icon */}
                <div className="w-10 h-10 flex-shrink-0 relative gap-3">
                  <div className=''>

               <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 0C22.1413 0 26.5925 1.84374 29.8744 5.12563C33.1563 8.40752 35 12.8587 35 17.5C35 22.1413 33.1563 26.5925 29.8744 29.8744C26.5925 33.1563 22.1413 35 17.5 35C12.8587 35 8.40752 33.1563 5.12563 29.8744C1.84374 26.5925 0 22.1413 0 17.5C0 12.8587 1.84374 8.40752 5.12563 5.12563C8.40752 1.84374 12.8587 0 17.5 0ZM18.4258 7.48047C16.3971 7.48047 14.793 8.05729 13.6133 9.21094C12.4023 10.3672 11.8281 11.9609 11.8281 13.9961H14.9609C14.9609 12.8438 15.1836 11.9336 15.6484 11.3008C16.1719 10.5312 17.0234 10.1758 18.2344 10.1758C19.1771 10.1706 19.9102 10.4271 20.4336 10.9453C20.9614 11.5316 21.2378 12.3017 21.2031 13.0898C21.1937 13.808 20.9308 14.4998 20.4609 15.043L20.1328 15.4258C18.3438 17.0234 17.2734 18.1758 16.9141 18.9219C16.5312 19.6641 16.3672 20.5703 16.3672 21.6172V22H19.5273V21.6133C19.5273 20.9531 19.6641 20.3789 19.9414 19.8281C20.2076 19.2984 20.5814 18.83 21.0391 18.4531C22.3594 17.2969 23.1562 16.5547 23.4062 16.2812C24.0664 15.3984 24.4219 14.2734 24.4219 12.8984C24.4219 11.2214 23.8724 9.90104 22.7734 8.9375C21.6719 7.94922 20.2148 7.48047 18.4258 7.48047ZM17.9336 23.3477C17.656 23.3398 17.3795 23.3868 17.1201 23.486C16.8607 23.5852 16.6234 23.7346 16.4219 23.9258C16.2196 24.1147 16.0608 24.3453 15.9563 24.6015C15.8517 24.8578 15.804 25.1337 15.8164 25.4102C15.8164 26.0156 16.0078 26.5117 16.4219 26.8945C16.8258 27.286 17.3672 27.5033 17.9297 27.5C18.5352 27.5 19.0273 27.3047 19.4414 26.9219C19.6461 26.7277 19.8081 26.4929 19.917 26.2327C20.026 25.9724 20.0795 25.6923 20.0742 25.4102C20.0793 25.1346 20.0282 24.8609 19.9241 24.6057C19.82 24.3505 19.6651 24.1192 19.4688 23.9258C19.0504 23.5403 18.4984 23.3329 17.9297 23.3477" fill="#006633"/>
</svg>
</div>

                  {/* Hidden logo placeholder (as per spec) */}
                  <div className="absolute inset-0 opacity-0">
                    <img
                      src="https://placehold.co/40x40"
                      alt="logo"
                      className="w-full h-full"
                    />
                  </div>
                </div>

                {/* Question and chevron */}
                <div className="flex-1 flex justify-between items-center">
                  <h3 className="m-3 font-medium text-[24px] leading-[29px] text-[#141414]">
                    {faq.question}
                  </h3>
                  {/* Chevron icon */}
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="focus:outline-none"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="#898989"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Answer section (only visible when open) */}
              {isOpen && (
                <div className="mt-4 flex items-start gap-[29px] pl-6">
                  {/* Vertical line (Line 32) */}
                  <div className="w-[1px] h-[40px] bg-[#898989]" />
                  {/* Answer text */}
                  <p className="text-[16px] leading-[19px] text-[#898989] flex-1">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
    <Overlaycard/>
<Footer/>
    </>
  );
};

export default HeroSection;